import { useCallback, useEffect, useRef, useState } from 'react';

// Locks a "run" button after `max` failed runs in a row (an AI tool that keeps answering "server busy"), for `lockSeconds`, with a
// countdown. A success, or the lock running out, starts the count again. Out-of-credits is not a failure of the run: don't record it.
export default function useFailureLock(max = 3, lockSeconds = 60) {
    const failures = useRef(0);
    const [secondsLeft, setSecondsLeft] = useState(0);

    useEffect(() => {
        if (secondsLeft <= 0) return undefined;
        const id = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
        return () => clearTimeout(id);
    }, [secondsLeft]);

    const recordFailure = useCallback(() => {
        failures.current += 1;
        if (failures.current >= max) { failures.current = 0; setSecondsLeft(lockSeconds); }
    }, [max, lockSeconds]);
    const recordSuccess = useCallback(() => { failures.current = 0; }, []);

    return { locked: secondsLeft > 0, secondsLeft, recordFailure, recordSuccess };
}
